import { IApplication } from "../Interfaces/Application/IApplication";
import { ICustomField } from "../Interfaces/Common/ICustomField";
import { ICustomer } from "../Interfaces/Customer/ICustomer";

export default class Application {
  private application: IApplication;
  private customFields: ICustomField[];

  constructor(application: IApplication, customFields: ICustomField[]) {
    this.application = application;
    // the custom fields associated with an app.
    this.customFields = customFields;
  }

  getCustomerByRole = (roleName: string) => {
    return this.application.appCustomers.find(
      x => x.customer.customerRole.name === roleName
    );
  };

  getPrimaryApplicant = (): ICustomer => {
    return this.application.appCustomers.find(
      x => x.customer.customerRole.name === "Applicant"
    )!.customer;
  };

  getCobuyer1 = (): ICustomer | undefined | null => {
    return this.application.appCustomers.find(
      x => x.customer.customerRole.name === "Co-buyer 1"
    )?.customer;
  };

  getCobuyer2 = (): ICustomer | undefined | null => {
    return this.application.appCustomers.find(
      x => x.customer.customerRole.name === "Co-buyer 2"
    )?.customer;
  };

  hasCobuyer1 = (): boolean => {
    return this.application.appCustomers.some(
      x => x.customer.customerRole.name === "Co-buyer 1"
    );
  };

  hasCobuyer2 = (): boolean => {
    return this.application.appCustomers.some(
      x => x.customer.customerRole.name === "Co-buyer 2"
    );
  };

  getCustomFieldValue = (name: string): string => {
    // const val:
    //   | IAppUserDefinedField
    //   | undefined = this.application.appUserDefinedField.find(
    //   x => x.userDefinedField.fieldName === name
    // );
    // if (val) {
    //   return val.value;
    // }
    return "";
  };

  setCustomFieldValue = (name: string, value: string): void => {
    // const val:
    //   | IAppUserDefinedField
    //   | undefined = this.application.appUserDefinedField.find(
    //   x => x.userDefinedField.fieldName === name
    // );
    // if (val) {
    //   val.value = value;
    // } else {
    //   const customField: ICustomField = this.customFields.find(
    //     x => x.fieldName === name
    //   )!;
    //   const appUdf: IAppUserDefinedField = {
    //     id: -1,
    //     applicationId: this.application.id,
    //     userDefinedFieldId: customField.id,
    //     value: value,
    //     domainId: uuid().toString(),
    //     userDefinedFieldValueId: -1,
    //     createdDate: new Date(),
    //     modifiedDate: new Date(),
    //     userDefinedField: customField
    //   };
    //   this.application.appUserDefinedField = this.application.appUserDefinedField.concat(
    //     appUdf
    //   );
    // }
  };
}
